import bulkArticles from '../middlewares/bulkArticles';
import constants from '../../../../settings/constants';

export default [bulkArticles(constants.BULK_ARTICLES)];
